import { useEffect } from "react";

// Studio kept marketing pages for products it does not provision. Those pages
// now live on the corporate site, and the old Studio paths hand the visitor
// over rather than 404ing on a link somebody already published.
export function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <section className="section">
      <div className="container">
        <p>
          Taking you to <a href={to}>{to}</a>.
        </p>
      </div>
    </section>
  );
}
